var Handlebars = require("/home/travis/build/thelounge/lounge/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<li class=\"context-menu-divider\" />\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./client/views/contextmenu_divider.tpl
// module id = 231
// module chunks = 0